<h5>配送センサーアラート</h5>
<div class="tw-h-full tw-overflow-y-auto">
  <mat-accordion multi>
    @for (
      alertsPerShipment of filteredAlertList;
      track alertsPerShipment.shipmentId
    ) {
      @if ((alertsPerShipment.alertDetails?.length ?? 0) > 0) {
        <!-- 一つのアラートのサマリ -->
          <mat-expansion-panel [id]="alertsPerShipment.shipmentId">
            <mat-expansion-panel-header
              class="!tw-h-[75px]"
              [ngClass]="{
                '!tw-bg-red-300': isAlert(alertsPerShipment),
                '!tw-bg-yellow-300': !isAlert(alertsPerShipment),
              }"
            >
              <mat-panel-title class="tw-text-xl">
                <a
                  [routerLink]="['/shipment-info']"
                  [queryParams]="getShipmentInfoLinkPrams(alertsPerShipment)"
                  class="tw-max-w-56 tw-truncate"
                >
                  {{ alertsPerShipment.shipmentName }}
                </a>
              </mat-panel-title>
              <mat-panel-description>
                <div class="tw-flex tw-w-full tw-h-14 tw-items-center">
                  <div class="tw-flex-col tw-w-full">
                    <div>
                      上限アラート：
                      {{
                        deviceAlertCount(
                          alertsPerShipment.shipmentId,
                          "alertMax"
                        )
                      }}
                    </div>
                    <div>
                      下限アラート：
                      {{
                        deviceAlertCount(
                          alertsPerShipment.shipmentId,
                          "alertMin"
                        )
                      }}
                    </div>
                    <div class="tw-pl-7">
                      アラート：
                      {{
                        deviceAlertCount(alertsPerShipment.shipmentId, "alert")
                      }}
                    </div>
                  </div>
                  <div class="tw-flex-col tw-w-full">
                    <div>
                      ワーニング：
                      {{
                        deviceAlertCount(
                          alertsPerShipment.shipmentId,
                          "prealertMax"
                        )
                      }}
                    </div>
                    <div>
                      ワーニング：
                      {{
                        deviceAlertCount(
                          alertsPerShipment.shipmentId,
                          "prealertMin"
                        )
                      }}
                    </div>
                    <!-- 空白を埋めるため -->
                    <div class="tw-h-[21px]"></div>
                  </div>

                  <div class="tw-flex-col tw-w-full">
                    <span> 最新発生日時: </span>
                    <div>
                      {{
                        alertsPerShipment.latestEventAt
                          | date: "yyyy/MM/dd HH:mm:ss"
                      }}
                    </div>
                  </div>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- アラート一覧のアコーディオン -->
            @for (
              alert of alertsPerShipment.alertDetails ?? [];
              track trackByAlert($index, alert)
            ) {
              <div [id]="createAlertId(alert)">
                <!-- アラートの場合 -->
                @if (
                  alert.status === "AlertMax" ||
                  alert.status === "AlertMin" ||
                  alert.status === "Alert"
                ) {
                  <button
                    class="tw-w-full tw-border-0 tw-bg-red-100"
                    [ngClass]="{
                      'tw-font-bold tw-text-red-500': isSelectedAlert(alert),
                    }"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                    (click)="selectedAlert(alert)"
                  >
                    <div class="tw-flex tw-items-center tw-h-12 tw-ml-8">
                      <div>
                        <mat-icon>error</mat-icon>
                      </div>
                      <div class="tw-flex tw-items-center tw-w-ful">
                        @if (alert.status === "AlertMax") {
                          <div class="tw-w-40">
                            {{ getSensorName(alert.sensor.label) }}上限アラート:
                          </div>
                          <div class="tw-w-24">
                            {{ alert.value | numeral: "0.0" }}
                            {{ alert.sensor.unit }}
                          </div>
                          <div class="tw-w-36">
                            （上限 {{ alert.threshold | numeral: "0.0" }}
                            {{ alert.sensor.unit }}）
                          </div>
                        } @else if (alert.status === "AlertMin") {
                          <div class="tw-w-40">
                            {{ getSensorName(alert.sensor.label) }}下限アラート:
                          </div>
                          <div class="tw-w-24">
                            {{ alert.value | numeral: "0.0" }}
                            {{ alert.sensor.unit }}
                          </div>
                          <div class="tw-w-36">
                            （下限 {{ alert.threshold | numeral: "0.0" }}
                            {{ alert.sensor.unit }}）
                          </div>
                        } @else if (alert.sensor.label === "shockDetected") {
                          <!-- 衝撃検知の表示を変える -->
                          <div class="tw-w-40">
                            {{ getSensorName(alert.sensor.label) }}アラート：
                          </div>
                          <div class="tw-w-24">
                            （{{ alert.threshold ?? "-" }} G）
                          </div>
                          <div class="tw-w-36"></div>
                        } @else if (alert.sensor.label === "lightExposure") {
                          <!-- 明暗検知の表示を変える -->
                          <div class="tw-w-40">
                            {{
                              getSensorName(
                                alert.sensor.label,
                                alert.eventType
                              )
                            }}アラート：
                          </div>
                          <div class="tw-w-24">
                            （{{ alert.value ?? "-" }} Lux）
                          </div>
                          <div class="tw-w-36"></div>
                        } @else {
                          <!-- 幅を揃えるため、空要素を設ける -->
                          <div class="tw-w-40">
                            {{
                              getSensorName(
                                alert.sensor.label,
                                alert.eventType
                              )
                            }}アラート:
                          </div>
                          <div class="tw-w-24"></div>
                          <div class="tw-w-36"></div>
                        }
                      </div>

                      <div class="tw-flex-col tw-w-full tw-ml-8">
                        <div>
                          検知:
                          {{ alert.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                        </div>
                        <div>
                          通知:
                          {{ alert.reportedAt | date: "yyyy/MM/dd HH:mm:ss" }}
                        </div>
                      </div>
                    </div>
                  </button>
                }

                <!-- プリアラートの場合 -->
                @if (
                  alert.status === "PreAlertMax" ||
                  alert.status === "PreAlertMin" ||
                  alert.status === "PreAlert"
                ) {
                  <button
                    class="tw-w-full tw-border-0 tw-bg-yellow-100"
                    [ngClass]="{
                      'tw-font-bold tw-text-red-500': isSelectedAlert(alert),
                    }"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                    (click)="selectedAlert(alert)"
                  >
                    <div class="tw-flex tw-items-center tw-h-12 tw-ml-8">
                      <div class="tw-w-ful">
                        <mat-icon>warning</mat-icon>
                      </div>
                      <div class="tw-flex tw-items-center tw-w-ful">
                        @if (alert.status === "PreAlertMax") {
                          <div class="tw-w-40">
                            {{
                              getSensorName(alert.sensor.label)
                            }}上限ワーニング:
                          </div>
                          <div class="tw-w-24">
                            {{ alert.value | numeral: "0.0" }}
                            {{ alert.sensor.unit }}
                          </div>
                          <div class="tw-w-36">
                            （上限 {{ alert.threshold | numeral: "0.0" }}
                            {{ alert.sensor.unit }}）
                          </div>
                        } @else if (alert.status === "PreAlertMin") {
                          <div class="tw-w-40">
                            {{
                              getSensorName(alert.sensor.label)
                            }}下限ワーニング:
                          </div>
                          <div class="tw-w-24">
                            {{ alert.value | numeral: "0.0" }}
                            {{ alert.sensor.unit }}
                          </div>
                          <div class="tw-w-36">
                            （下限 {{ alert.threshold | numeral: "0.0" }}
                            {{ alert.sensor.unit }}）
                          </div>
                        } @else {
                          <!-- 幅を揃えるため、空要素を設ける -->
                          <div class="tw-w-40">
                            {{
                              getSensorName(
                                alert.sensor.label,
                                alert.eventType
                              )
                            }}ワーニング
                          </div>
                          <div class="tw-w-24"></div>
                          <div class="tw-w-36"></div>
                        }
                      </div>

                      <div class="tw-flex-col tw-w-full tw-ml-8">
                        <div>
                          検知:
                          {{ alert.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                        </div>
                        <div>
                          通知:
                          {{ alert.reportedAt | date: "yyyy/MM/dd HH:mm:ss" }}
                        </div>
                      </div>
                    </div>
                  </button>
                }
              </div>
            }
          </mat-expansion-panel>
      }
    }
  </mat-accordion>

  @if (alertList.length < 1 && !loading) {
    <div>対象期間内に配送センサーアラートはありません。</div>
  } @else if (
    alertList.length > 0 && filteredAlertList.length < 1 && !loading
  ) {
    <div>対象範囲内に配送センサーアラートはありません。</div>
  }
</div>
